module.exports = __webpack_public_path__ + "/static/assets/504d73be1b361b4b9ca7f655ce085dc6.svg";